import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "greeting" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "“Turfy” Dog Greeting", -1)
const _hoisted_3 = { class: "day-title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sections, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "list",
        style: _normalizeStyle({ 'margin-bottom': i === 0 ? '20px' : '' })
      }, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(item.name), 1),
        _createElementVNode("table", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.times, (list) => {
            return (_openBlock(), _createElementBlock("tr", null, [
              _createElementVNode("td", null, _toDisplayString(list.time), 1)
            ]))
          }), 256))
        ])
      ], 4))
    }), 256))
  ]))
}